    import { sendOtpStart, sendOtpSuccess, sendOtpError } from "./reducer";
    import { ThunkAction } from "redux-thunk";
    import { Action, Dispatch } from "redux";
    import { RootState } from "slices";
    import {forgotPassword as forgotPasswordApi } from "helpers/backend_helper";
    import { toast } from "react-toastify";

    interface ForgotPasswordPayload {
        email: string;
    }

    export const forgotPassword =
        (
            payload: ForgotPasswordPayload,
            navigate: any
        ): ThunkAction<void, RootState, unknown, Action<string>> =>
            async (dispatch: Dispatch) => {
                dispatch(sendOtpStart(payload.email));
                try {
                    const response: any = await forgotPasswordApi(payload);                    
                    if (response && response.data && response.data.success) {
                        dispatch(sendOtpSuccess());
                        toast.success("OTP has been sent to your email!");
                        
                        // Redirect to a confirmation page if needed
                        navigate("/otp-verification");
                    }
                    else {
                        throw new Error("Failed to sent OTP")
                    }
                } catch (error: any){
                    dispatch(sendOtpStart(error.message))
                    toast.error("Failed to send password reset email");
                }
            }